(() => {
  if (window.__hubSlideshowInit) return;
  window.__hubSlideshowInit = true;

  const setSlideShow = () => {
    document.querySelectorAll(".component-hub-slideshow").forEach((slider) => {
      if (slider.swiper) return;
      const id = slider.getAttribute("id");
      new Swiper(`#${id}`, {
        direction: "horizontal",
        slidesPerView: 1.5,
        spaceBetween: 16,
        simulateTouch: true,
        allowTouchMove: true,
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
        },
        navigation: {
          nextEl: `#${id} .swiper-button-next`,
          prevEl: `#${id} .swiper-button-prev`,
        },
      });
    });
  };

  const setRoundImageTeaserSlider = () => {
    document.querySelectorAll(".component-round-image-teaser").forEach((slider) => {
      if (slider.swiper) return;
      const id = slider.getAttribute("id");
      new Swiper(`#${id}`, {
        direction: "horizontal",
        slidesPerView: 1.35,
        spaceBetween: 16,
        grabCursor: true,
        simulateTouch: true,
        allowTouchMove: true,
        watchOverflow: true,
        navigation: {
          nextEl: `#${id} .swiper-button-next`,
          prevEl: `#${id} .swiper-button-prev`,
        },
        breakpoints: {
          600: {
            slidesPerView: 2.35,
            spaceBetween: 16,
          },
          900: {
            slidesPerView: 3.35,
            spaceBetween: 16,
          },
          1200: {
            slidesPerView: 3.65,
            spaceBetween: 16,
          },
        },
      });
    });
  };

  setSlideShow();
  setRoundImageTeaserSlider();
})();
